<template>
  <div>
    <van-nav-bar title="频道列表">
      <template #right>
      <span style="display: inline-block"
          ><img style="width: 28px;padding-top: 11px !important;" src="../assets/images/sound.png"
        /></span>
        <span style="display: inline-block;padding: 3px;">
          <van-switch
            id="channel-chat-mute-switch-btn"
            :active-value="1"
            :inactive-value="0"
            size="24"
            v-model="wonder_channel_notice_sound"
          />
        </span>
        <van-icon
          name="search"
          color="#ffffff"
          size="24px"
          @click="$router.push({ name: 'ChannelSearch'})"
        />
      </template>
      
    </van-nav-bar>

    <div style="">
    <van-loading
          v-if="loadChannels"
          style="text-align: center; padding-top: 20px"
          >{{$t("app.common.loading")}}</van-loading
        >
      <div v-for="item in $store.state.channel_list" :key="item.id">
        <van-row
          class="rowDesign"
          @click="joinForGroup(item.id,item.user.name)"
        >
          <van-col span="4">
            <img :src="item.user.avatar" class="imageStyle" />
          </van-col>
          <van-col span="12" class="channelUserStyle">
            <van-row class="channelUserRowStyle long_group_name" >
               <span>{{ item.user.username }}</span>
            </van-row>
            <van-row class="messageStyle">
              <span>{{
                item.messages.length > 0 &&
                item.messages[item.messages.length - 1].format == 0
                  ? item.messages[item.messages.length - 1].content
                  : ""
              }}</span> 
            </van-row>
          </van-col>
          <van-col :span="(item.join == 0) ? 4:8" style="text-align: right">
            <van-badge
              :content="item.unread > 0 ? item.unread : ''"
              style="padding: 6px 14px; margin-top: 5px"
            />
          </van-col>
          <van-col span="4" v-if="item.join == 0">
            <span><van-button style="margin-top: 10px;" type="primary" size="mini">加入群组</van-button>
            </span>
          </van-col>
        </van-row>
      </div>
      
    </div>
    <van-dialog v-model="channelJoin" show-cancel-button :beforeClose="checkPermission" title="加入群组">
      <van-cell-group>
        <van-field type="password" v-model="channelPassword" placeholder="输入群组密码" />
      </van-cell-group>
    </van-dialog>
  </div>
</template>

<script>
import md5 from "js-md5";
export default {
  name: "ChannelRoom",
  data() {
    return {
      channelList: [],
      channelsList: [],
      isMute: 0,
      loadChannels:false,
      channelJoin:false,
      channelPassword: "",
      channelName:"",
      channelId:"",
      blockPermission:""
    };
  },
  computed: {
    wonder_channel_notice_sound: {
      get() {
        return this.$store.state.wonder_channel_notice_sound;
      },
      set(value) {
        this.$store.commit("updateWonderChannelSound", value);
      },
    },
  },
  methods: {
    getPermission(){
        let that = this;
        that.loadChannels = true;
        that
        .$wonderChat({
          url: "api/group/getPermission/"+that.account,
          method: "post",
          headers: {
            "access-token": that.$store.state.wonder_chat_token,
          },
          data: {},
        })
        .then((res) => {
          let resData = res.data;
          if(resData.code == 200){
            that.blockPermission = resData.data.blocked;
          } else{
              
          } 
        });
    },
    getChannelsList(){
        let that = this;
        that.loadChannels = true;
        that
        .$wonderChat({
          url: "api/group/list?type=1",
          method: "get",
          headers: {
            "access-token": that.$store.state.wonder_chat_token,
          },
          data: {},
        })
        .then((res) => {
          that.loadChannels = false;
          if (res.data.code == 200) {
            let resData = res.data.dataList;
            that.channelsList = resData;  
            that.$store.commit("updateChannelList", res.data.dataList);
          }
        });
    }, 
    joinForGroup(id,name){
      let that = this;
        that
        .$wonderChat({
          url: "api/group/member/join/"+id,
          method: "post",
          headers: {
            "access-token": that.$store.state.wonder_chat_token,
          },
          data: {
            password:'',
          },
        })
        .then((res) => {
          let resData = res.data;
          if(resData.code == 200){
              that.$router.push({ name: 'ChannelRoomUser', params: { account: id, groupname: name } });
              let data = {
                  channelId: id,
                  data: resData.data
                };
              that.$store.commit("updateChannelJoinStatus", data);
          } else if(resData.code == 403){
              that.channelJoin = true;
              that.channelPassword = "";
              that.channelId = id;
              that.channelName = name;
          } else if(resData.code == 406){
              that.$toast.fail(that.$t(resData.msg));
          } else{
              that.$toast.fail(that.$t(resData.msg));
          }
        });
    },
    checkPermission(action,done){
        let that = this;
        switch (action) {
          case 'confirm':
            if (!that.channelPassword) {
              this.$toast({
                type: 'warning',
                message: that.$t('app.channel_room.group_pw')
              });
              done(false);
            }else{
                that
                .$wonderChat({
                  url: "api/group/member/join/"+that.channelId,
                  method: "post",
                  headers: {
                    "access-token": that.$store.state.wonder_chat_token,
                  },
                  data: {
                    password:md5(that.channelPassword),
                  },
                })
                .then((res) => {
                  let resData = res.data;
                  if(resData.code == 200){
                    that.$toast({
                      message: that.$t('app.common.success'),
                      type: 'success',
                      onClose: function () {
                        that.$router.push({ name: 'ChannelRoomUser', params: { account: that.channelId, groupname: that.channelName } });
                        let data = {
                            channelId: that.channelId,
                            data: resData.data
                        };
                        that.$store.commit("updateChannelJoinStatus", data);
                        done()
                      }
                    });
                      
                  } else{
                      that.$toast.fail(this.$t('app.channelroom.pw_error'));
                      done(false);
                  }
                });
            }

            break;
          case 'cancel':
            done();
            break;
        }
    },
    isLogin() {
      if (!this.$store.state.loginType) {
        this.$router.push("/login");
      }
    },
    setMute() {
      var checkbox = this.isMute;
      if (checkbox == 1) {
        this.voice();
        localStorage.setItem("isChannelMuteMobile", false);
      } else {
        localStorage.setItem("isChannelMuteMobile", true);
      }
    },
    voice() {
      var audio = document.createElement("audio");
      audio.src =
        process.env.WONDER_CHAT_ROOT +
        "/resource/layim/css/modules/layim/voice/default.mp3";
      audio.play();
    },
  },
  mounted: function () {
    this.isLogin();
    this.getChannelsList();  
    //this.getPermission();  
  },
};
</script>

<style scoped>
.long_group_name{
  text-overflow: ellipsis; 
  overflow: hidden;
  white-space: nowrap;
}
.rowDesign {
  padding: 4px 10px;
  border-bottom: 1px solid #dcdee0;
}

.imageStyle {
  width: 40px;
  border-radius: 25px;
}

.channelUserStyle {
  text-align: left;
  padding-right: 10px;
}

.channelUserRowStyle {
  padding-top: 3px;
  color: #000000;
}

.messageStyle {
  color: #969799;
  font-size: 12px;
  white-space: nowrap;
  overflow: hidden !important;
  text-overflow: ellipsis;
}

#channel-chat-mute-switch-btn {
  font-size: 18px !important;
  float: right;
}
</style>


// WEBPACK FOOTER //
// src/components/ChannelRoom.vue